angular.module('unergie.main')
.factory('TimetableModificationsService', () => {
    const MIN = 0
    const MAX = 1.8

    const MAX_HEIGHT = 600

    const amountFilter = function (amount) {
        const s = amount.toFixed(2)
        return s === '-0.00' ? '0.00' : s
    }

    // const toDate = (dateString) => moment(dateString, 'YYYY-MM-DD').toDate()

    const display = function (selector, timetables) {
        const vis = document.querySelector(selector)
        const MAX_WIDTH = vis.getBoundingClientRect().width
        const margin = { top: 0, right: 0, bottom: 70, left: 30 }
        const width = MAX_WIDTH - margin.left - margin.right
        const height = MAX_HEIGHT - margin.top - margin.bottom

        const div = d3.select('body').append('div')
        .attr('class', 'graph-tooltip')
        .style('opacity', 0)

        const data = []

        const formatTick = function (index) {
            if ((index === 0) || (index > timetables.length)) {
                return ''
            }
            return `${timetables[index - 1].month}/${timetables[index - 1].year}`
        }

        d3.selectAll(selector).select('svg').remove()

        const svg = d3.select(selector).append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

        const x = d3.scaleLinear().range([0, width])
        const y = d3.scaleLinear().range([height, 0])

        const computeRatio = (datum) => Math.max(0, (1 + (datum.timetable.modification / datum.height)) * (1 + ((datum.timetable.revision / 100) || 0)))

        const resetDatum = function (datum) {
            datum.lock = false
            datum.grabed = false
            datum.height = datum.timetable.total
            datum.ratio = computeRatio(datum)
        }

        const computedHeight = (datum) => (datum.height * computeRatio(datum))

        let i = 0
        const n = timetables.length
        let elem
        while (i < n) {
            elem = {
                timetable: timetables[i],
            }
            elem.xOffset = i + 1
            resetDatum(elem)
            data.push(elem)
            i += 1
        }

        const barWidth = Math.min(30, parseInt((width / data.length), 10) - 1)
        const selectableWidth = parseInt((width / (data.length + 1)), 10) / 2

        const MAX_TIMETABLE_VALUE = _.max(data.map((d) => d.height * MAX))

        x.domain([0, data.length + 1])
        y.domain([0, MAX_TIMETABLE_VALUE + 5])

        const toggleLock = function (d) {
            d.lock = !d.lock
            svg.select(`.lock${d.xOffset}`).attr('xlink:href', (datum) => { if (datum.lock) { return '/images/assets/img/locked.png' } return '/images/assets/img/unlocked.png' })
            svg.select(`circle.graber${d.xOffset}`).style('fill', d.lock ? 'black' : 'white')
        }

        const leftLock = function (d) {
            for (let cpt = d.xOffset; cpt > 0; cpt -= 1) {
                toggleLock(_.find(data, { xOffset: cpt }))
            }
        }

        const rightLock = function (d) {
            for (let cpt = d.xOffset; cpt <= data.length; cpt += 1) {
                toggleLock(_.find(data, { xOffset: cpt }))
            }
        }

        const showArrows = (d) => {
            svg.selectAll('.rightarrow').style('visibility', 'hidden')
            svg.selectAll('.leftarrow').style('visibility', 'hidden')
            svg.select(`.rightarrow${d.xOffset}`).style('visibility', '')
            svg.select(`.leftarrow${d.xOffset}`).style('visibility', '')
        }

        const hideArrows = () => {
            svg.selectAll('.rightarrow').style('visibility', 'hidden')
            svg.selectAll('.leftarrow').style('visibility', 'hidden')
        }

        // const tooltip = function (elem) {}

        // const tooltipButton = (string) => () => string

        // const reset = function () {
        //     _.forEach(data, (datum) => {
        //         datum.timetable.modification = 0
        //         datum.timetable.revision = 0
        //         resetDatum(datum)
        //         refreshTimetable(datum)
        //     })
        // }

        // const flatten = function () {
        //     const unlocked = getUnlockedTimetables()
        //     const total = _.reduce(unlocked, (sum, n) => sum + (n.height * n.ratio), 0)
        //     const average = total / unlocked.length
        //     return _.forEach(unlocked, (datum) => {
        //         datum.ratio = average / datum.height
        //         refreshRectWithTimetable(datum)
        //         refreshCircleWithTimetable(datum)
        //         refreshTextWithTimetable(datum)
        //     })
        // }

        let grabing = false
        let grabbedTimetable = null

        const grab = function (timetable) {
            grabing = true
            grabbedTimetable = timetable
            timetable.grabed = true
            return d3.select(this).classed('selection', true)
        }

        const ungrab = function () {
            grabbedTimetable = null
            grabing = false
            data.forEach((datum) => (datum.grabed = false))
            return d3.selectAll('g.selected').classed('selected', false)
        }

        const getUnlockedTimetables = () => _.filter(data, { lock: false, grabed: false })

        const xAxis = d3.axisBottom(x)
        .ticks(data.length + 2)
        .tickFormat(formatTick)
        .tickSize(0)

        // const tooltipOn = function (tooltipFunc, d) {
        //     div.transition()
        //     .duration(200)
        //     .style('opacity', 0.9)
        //     return div.html(tooltipFunc(d))
        //     .style('left', `${d3.event.pageX + 20}px`)
        //     .style('top', `${d3.event.pageY - 28}px`)
        // }

        const tooltipOff = (d) =>
            div.transition()
            .duration(500)
            .style('opacity', 0)


        // BACKGROUND
        svg.append('rect')
        .attr('class', 'tbground')
        .attr('x', (d) => -margin.left)
        .attr('width', (d) => MAX_WIDTH)
        .attr('y', (d) => -margin.top)
        .attr('height', (d) => MAX_HEIGHT)
        .on('mouseleave', hideArrows)

        // max line
        svg.append('line')
        .attr('x1', margin.left)
        .attr('y1', y(MAX_TIMETABLE_VALUE))
        .attr('x2', width - 30)
        .attr('y2', y(MAX_TIMETABLE_VALUE))
        .attr('stroke-width', 1)
        .attr('stroke', 'red')
        .attr('stroke-dasharray', '4px')

        // Selection bars
        svg.selectAll('.bin')
        .data(data)
        .enter().append('rect')
        .attr('class', (d) => `toggleshow${d.xOffset}`)
        .attr('x', (d) => x(d.xOffset) - selectableWidth)
        .attr('width', (d) => selectableWidth * 2)
        .attr('y', (d) => 0 + 35)
        .attr('height', (d) => height + 35)
        .attr('fill', (d) => 'white')
        .style('opacity', 0)
        .on('mouseover', showArrows)

        // BARS !
        svg.selectAll('.bin')
        .data(data)
        .enter().append('rect')
        .attr('class', (d) => `timetablebar${d.xOffset}`)
        .attr('ry', 3)
        .attr('x', (d) => x(d.xOffset) - (barWidth / 2))
        .attr('width', (d) => barWidth)
        .attr('y', (d) => y(computedHeight(d)))
        .attr('height', (d) => height - y(computedHeight(d)))
        .attr('fill', (d) => 'steelblue')
        .style('opacity', 0.65)

        // Hollows
        svg.selectAll('.bin')
        .data(data)
        .enter().append('rect')
        .attr('class', (d) => `timetablehollow${d.xOffset}`)
        .attr('ry', 3)
        .attr('x', (d) => x(d.xOffset) - (barWidth / 2))
        .attr('width', (d) => barWidth)
        .attr('y', (d) => y(d.height))
        .attr('height', (d) => height - y(d.height))
        .attr('fill', (d) => 'grey')
        .style('opacity', 0.3)

        // X AXIS
        svg.append('g')
        .attr('class', 'x axis transparent')
        .attr('transform', `translate(0, ${height})`)
        .call(xAxis)

        // Amount label
        svg.selectAll('.bin')
        .data(data)
        .enter().append('text')
        .attr('class', (d) => `amountlabel amountlabel${d.xOffset}`)
        .text((d) => `${amountFilter(computedHeight(d))}€`)
        .attr('x', function (d) { return x(d.xOffset) - (this.getComputedTextLength() / 2) })
        .attr('y', (d) => y(computedHeight(d)) - 15)
        .attr('dy', '.35em')
        .attr('fill', 'black')

        // REVISION label
        svg.selectAll('.bin')
        .data(data)
        .enter().append('text')
        .attr('class', (d) => `percentlabel percentlabel${d.xOffset}`)
        .text((d) => (d.timetable.revision ? `${d.timetable.revision}%` : ''))
        .attr('x', function (d) { return x(d.xOffset) - (this.getComputedTextLength() / 2) })
        .attr('y', (d) => y(computedHeight(d) / 2))
        .attr('dy', '.35em')
        .attr('fill', (d) => (d.timetable.revision > 0 ? 'red' : 'green'))

        // Locks icons
        svg.selectAll('.bin')
        .data(data)
        .enter().append('image')
        .attr('class', (d) => `lock lock${d.xOffset}`)
        .attr('xlink:href', (d) => { if (d.lock) { return '/images/assets/img/locked.png' } return '/images/assets/img/unlocked.png' })
        .attr('x', (d) => x(d.xOffset) - (barWidth / 2))
        .attr('y', (d) => height + 25)
        .attr('width', 32)
        .attr('height', 32)
        .on('click', toggleLock)

        // right arrow
        svg.selectAll('.bin')
        .data(data.slice(0, -1))
        .enter().append('image')
        .attr('class', (d) => `rightarrow rightarrow${d.xOffset}`)
        .attr('xlink:href', '/images/assets/img/right_arrow.png')
        .attr('x', (d) => (x(d.xOffset) - (barWidth / 2)) + 24)
        .attr('y', (d) => height + 23)
        .attr('width', 32)
        .attr('height', 32)
        .style('visibility', 'hidden')
        .on('click', rightLock)

        // left arrow
        svg.selectAll('.bin')
        .data(data.slice(1))
        .enter().append('image')
        .attr('class', (d) => `leftarrow leftarrow${d.xOffset}`)
        .attr('xlink:href', '/images/assets/img/left_arrow.png')
        .attr('x', (d) => (x(d.xOffset) - (barWidth / 2)) - 24)
        .attr('y', (d) => height + 23)
        .attr('width', 32)
        .attr('height', 32)
        .style('visibility', 'hidden')
        .on('click', leftLock)

        // Preload unlocked image
        svg.append('image')
        .attr('xlink:href', '/images/assets/img/locked.png')
        .attr('x', (d) => 0)
        .attr('y', (d) => 0)
        .attr('width', 32)
        .attr('height', 32)
        .style('display', 'none')

        // X AXIS labels
        svg.selectAll('.x text')
        .attr('transform', function (d) { return `translate(0,${this.getBBox().height})` })

        // Circles graber
        svg.selectAll('.bin')
        .data(data)
        .enter().append('circle')
        .attr('class', (d) => `graber graber${d.xOffset}`)
        .attr('r', 7)
        .attr('cx', (d) => x(d.xOffset))
        .attr('cy', (d) => y(computedHeight(d)))
        .style('stroke', 'black')
        .style('fill', 'white')
        .on('mousedown', grab)

        const refreshPercentWithTimetable = function (timetable) {
            const t = svg.select(`text.percentlabel${timetable.xOffset}`)
            t.attr('y', y(computedHeight(timetable) / 2))

            if (timetable.timetable.revision) {
                t.text(`${timetable.timetable.revision}%`)
            } else {
                t.text('')
            }
            t.style('fill', timetable.timetable.revision > 0 ? 'red' : 'green')
            t.attr('x', function (d) { return x(timetable.xOffset) - (this.getComputedTextLength() / 2) })
        }


        const refreshTextWithTimetable = function (timetable) {
            const t = svg.select(`text.amountlabel${timetable.xOffset}`)
            t.attr('y', y(computedHeight(timetable)) - 15)
            t.text(`${amountFilter(computedHeight(timetable))}€`)
            t.attr('x', function (d) { return x(timetable.xOffset) - (this.getComputedTextLength() / 2) })
        }

        const refreshRectWithTimetable = function (timetable) {
            const r = svg.select(`rect.timetablebar${timetable.xOffset}`)
            if (!r.empty()) {
                r.attr('y', y(computedHeight(timetable)))
                r.attr('height', height - y(computedHeight(timetable)))
            }
        }

        const refreshCircleWithTimetable = function (timetable) {
            const c = svg.select(`circle.graber${timetable.xOffset}`)
            if (!c.empty()) {
                c.attr('cy', y(computedHeight(timetable)))
                c.style('fill', timetable.lock ? 'black' : 'white')
            }
        }

        const refreshTimetable = (datum) => {
            refreshRectWithTimetable(datum)
            refreshCircleWithTimetable(datum)
            refreshTextWithTimetable(datum)
            refreshPercentWithTimetable(datum)
        }

        const reloadWithRevision = (revision) => {
            _.forEach(_.filter(data, { lock: false }), (datum) => {
                datum.timetable.revision = Number(revision)
                refreshTimetable(datum)
            })
        }

        const withDrawable = (timetable) => computedHeight(timetable)

        const distributable = (timetable) => MAX_TIMETABLE_VALUE - computedHeight(timetable)

        const add = function (datum, value) {
            datum.timetable.modification += value
        }

        svg.on('mousemove', function () {
            if (grabing && (grabbedTimetable !== null) && !grabbedTimetable.lock) {
                const p = d3.mouse(this)

                let unlockedTimetables = getUnlockedTimetables()

                const toDistributeMax = _.reduce(unlockedTimetables, (sum, tt) => sum + distributable(tt), 0)
                const toWithdrawMax = _.reduce(unlockedTimetables, (sum, tt) => sum + withDrawable(tt), 0)

                const toDistributeMaxPercent = (computedHeight(grabbedTimetable) - toDistributeMax) / grabbedTimetable.height
                const toWithdrawMaxPercent = (computedHeight(grabbedTimetable) + toWithdrawMax) / grabbedTimetable.height

                const localMax = MAX_TIMETABLE_VALUE / grabbedTimetable.height

                const infThreshold = Math.max(MIN, toDistributeMaxPercent)
                const supThreshold = Math.min(localMax, toWithdrawMaxPercent)

                const oldRatio = computeRatio(grabbedTimetable)
                grabbedTimetable.ratio = Math.max(infThreshold, Math.min(supThreshold, y.invert(p[1]) / grabbedTimetable.height))

                const maxToDistribute = grabbedTimetable.timetable.total + grabbedTimetable.timetable.modification

                const toDistribute = Math.min((oldRatio - (grabbedTimetable.ratio)) * grabbedTimetable.height, maxToDistribute)

                add(grabbedTimetable, -toDistribute)

                let ttLeft = unlockedTimetables.length

                let distributed = 0
                const leftToDistribute = () => toDistribute - distributed
                const toDistributeEach = () => leftToDistribute() / ttLeft

                if (toDistribute > 0) {
                    unlockedTimetables = _.sortBy(unlockedTimetables, distributable)
                    _.forEach(unlockedTimetables, (timetable) => {
                        const d = distributable(timetable)
                        const toD = toDistributeEach()
                        if (d > toD) {
                            add(timetable, toD)
                            distributed += toD
                        } else {
                            add(timetable, d)
                            distributed += d
                        }
                        return (ttLeft -= 1)
                    })
                } else {
                    unlockedTimetables = _.sortBy(unlockedTimetables, withDrawable)
                    _.forEach(unlockedTimetables, (timetable) => {
                        const d = -withDrawable(timetable)
                        const toD = toDistributeEach()
                        if (d < toD) {
                            add(timetable, toD)
                            distributed += toD
                        } else {
                            add(timetable, d)
                            distributed += d
                        }
                        return (ttLeft -= 1)
                    })
                }

                _.forEach(unlockedTimetables, (timetable) => {
                    refreshTimetable(timetable)
                })

                refreshTimetable(grabbedTimetable)
            }
        }).on('mouseup', () => {
            ungrab()
            return tooltipOff()
        }).on('mouseleave', () => {
            ungrab()
            return tooltipOff()
        })

        return {
            reloadWithRevision,
            getData: () => data,
        }
    }

    return {
        display,
    }
})
